export default __webpack_public_path__ + "static/media/gbp.7864b6bc.png";